<template>
  <v-app-bar app flat dark>
    <v-app-bar-nav-icon
      color="white"
      @click.stop="$store.dispatch('common/setDrawer', !drawer)"
    ></v-app-bar-nav-icon>
    <v-container class="py-0 full-height pl-0">
      <v-row class="full-height">
        <v-col cols="auto">
          <v-toolbar-title class="d-flex cursor-pointer" @click="goTo('/')">
            <v-img
              width="200"
              :src="$images.FULL_LOGO"
              v-if="$vuetify.breakpoint.mdAndUp"
            />
            <inline-svg
              width="25"
              height="25"
              :fill="$vuetify.theme.themes.light.accent"
              :src="$images.LOGO"
              v-else
            />
          </v-toolbar-title>
        </v-col>
        <v-spacer></v-spacer>
        <template v-if="settings.isPaidPlan">
          <v-col cols="auto" class="px-0" v-if="isSuperAdmin">
            <v-btn small color="white" icon @click="showInsights">
              <v-icon>
                insights
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" @click="goTo('/tasks')" class="cursor-pointer">
            <v-badge
              overlap
              color="primary"
              :content="taskCount"
              :value="taskCount"
            >
              <v-btn small color="white" icon @click="goTo('/tasks')">
                <v-icon>notifications</v-icon>
              </v-btn>
            </v-badge>
          </v-col>
        </template>
        <v-col cols="auto" class="px-2">
          <v-btn
            small
            color="white"
            icon
            href="https://help.corecounts.com/"
            target="_blank"
          >
            <v-icon>
              help
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="px-2">
          <v-btn small color="white" icon @click="showBeacon">
            <v-icon>
              feedback
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-menu absolute>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small color="white" icon v-bind="attrs" v-on="on">
                <user-avatar size="24" :user="profile"> </user-avatar>
              </v-btn>
            </template>

            <v-list>
              <v-list-item to="/profile">
                <v-list-item-action>
                  <v-icon>person</v-icon>
                </v-list-item-action>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/portal/customers"
                v-if="isSuperAdmin || isCoreCoach"
              >
                <v-list-item-action>
                  <v-icon>admin_panel_settings</v-icon>
                </v-list-item-action>
                <v-list-item-title>CorePortal</v-list-item-title>
              </v-list-item>
              <v-list-item to="/billing" v-if="is_admin && settings.isPaidPlan">
                <v-list-item-action>
                  <v-icon>attach_money</v-icon>
                </v-list-item-action>
                <v-list-item-title>Billing</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showRunAsDialog" v-if="isSuperAdmin">
                <v-list-item-action>
                  <v-icon>directions_run</v-icon>
                </v-list-item-action>
                <v-list-item-title>Run As</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-action>
                  <v-icon>logout</v-icon>
                </v-list-item-action>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <run-as-dialog ref="runAsDialog"></run-as-dialog>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import InlineSvg from "vue-inline-svg";
import RunAsDialog from "@/components/layout/RunAsDialog";
import { setRunAs } from "@/helpers/local";
export default {
  name: "AppBar",
  components: { InlineSvg, RunAsDialog },
  data: () => ({ menu: false }),
  watch: {},
  computed: {
    taskCount() {
      return this.tasks.length;
    },
    isSuperAdmin() {
      return this.$auth.isSuperAdmin();
    },
    isCoreCoach() {
      return this.$auth.isCoreCoach();
    },
    ...mapGetters({
      tasks: "task/tasks",
      drawer: "common/drawer",
      profile: "profile/profile",
      settings: "profile/settings",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager"
    })
  },
  methods: {
    goTo(link) {
      this.$router.push({ path: link });
    },
    logout() {
      setRunAs("", true);
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    showRunAsDialog() {
      this.$refs.runAsDialog.showDialog();
    },
    showInsights() {
      this.$store.dispatch("insights/setDrawer", true);
    },
    showBeacon() {
      window.Beacon("open");
    }
  }
};
</script>

<style lang="scss" scoped>
.setup-btn {
  background-color: white;
}

::v-deep .v-toolbar__content {
  padding-bottom: 0.1px;
}

::v-deep .v-toolbar__items {
  height: 100%;
}

.v-btn--active:not(.v-btn--icon) {
  border-bottom: 2px solid;
  color: var(--v-primary-base) !important;

  &::before {
    opacity: 0 !important;
  }
}

::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
